export const permissions = [
    {
        title: 'گواهی تایید فنی نرم افزار',
        logo: '/img/new/permissions/logo-04.webp',
        img: '/img/new/permissions/image-04.webp',
    },
    {
        title: 'رتبه یک از خدمات شورای انفورماتیک',
        logo: '/img/new/permissions/logo-02.webp',
        img: '/img/new/permissions/image-02.webp',
    },
    {
        title: 'پروانه ارائه خدمات ارتباطی ثابت از سازمان تنظیم مقررات و ارتباطات رادیویی',
        logo: '/img/new/permissions/logo-01.webp',
        img: '/img/new/permissions/image-01.webp',
    },
    {
        title: 'مجوز فعالیت از سازمان نظام صنفی رایانه‌ای',
        logo: '/img/new/permissions/logo-03.webp',
        img: '/img/new/permissions/image-03.webp',
    },
    {
        title: 'پروانه بهره‌برداری',
        logo: '/img/new/permissions/logo-05.webp',
        img: '/img/new/permissions/image-05.webp',
    },
];